import { CircleAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function AccountUnavailablePage({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="flex h-screen w-screen items-center justify-center bg-background px-6">
      <Card className="max-w-md w-full text-center">
        <CardHeader>
          <CircleAlert className="mx-auto mb-2 h-12 w-12 text-destructive" />
          <CardTitle>Couldn't load your account</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-muted-foreground">Check your connection and try again.</p>
          <Button onClick={onRetry}>Retry</Button>
        </CardContent>
      </Card>
    </div>
  );
}
